import React, { FC, Fragment } from 'react';
import { CourseBundleListItem } from './CourseBundleListItem';
import { ElearningDTO, mapToCourseExcerpt, mapToElearning } from 'src/common/models/elearning';
import { PageResultDTO } from 'src/common/models/page';
import { InfiniteData } from 'react-query';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { generateDetailsLink } from 'src/common/components/CourseCard/config';
import styled from 'styled-components';

const StyledLink = styled(GatsbyLink)`
  & {
    all: unset;
    cursor: pointer;
  }
`;

interface CourseBundleElearningListProps {
  elearnings?: InfiniteData<PageResultDTO<ElearningDTO>>;
}

export const CourseBundleElearningList: FC<CourseBundleElearningListProps> = ({ elearnings }) => (
  <>
    {elearnings?.pages.map((page, i) => (
      <Fragment key={i}>
        {page.result.map((elearning) => {
          const courseExcerpt = mapToCourseExcerpt(mapToElearning(elearning));
          return (
            <StyledLink key={elearning.id} to={generateDetailsLink(courseExcerpt)}>
              <CourseBundleListItem courseExcerpt={courseExcerpt} />
            </StyledLink>
          );
        })}
      </Fragment>
    ))}
  </>
);
